var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-menu g3" }, [
    _c("ul", [
      _c("li", { staticClass: "head" }, [_vm._v("Users")]),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("router-link", { attrs: { to: "/member/create" } }, [
            _vm._v("New user"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("router-link", { attrs: { to: "/member/list" } }, [
            _vm._v("Users"),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }